export default "__VITE_ASSET__DpTzokn7__"